module.exports = __webpack_public_path__ + "img/sideflag.bf70759.png";